import request from './request.js';
import {requestbody} from './request.js'

export async function updatePass (params = {}) {
	return await requestbody('/system/user/updatePass', 'post', params)
}
export async function checkPasswordTime (params = {}) {
	return await request('/checkPasswordTime', 'get', params)
}
